"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowTextEditor_1 = require("../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardRowCheckBoxEditor_1 = require("../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var CardEditorContainer_1 = require("../../../../../../shared/components/containers/CardEditorContainer");
var CardRowNumericEditor_1 = require("../../../../../../shared/components/editors/CardRowNumericEditor");
var CfgCurrencyEditor = /** @class */ (function (_super) {
    __extends(CfgCurrencyEditor, _super);
    function CfgCurrencyEditor(props) {
        return _super.call(this, props) || this;
    }
    CfgCurrencyEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    title: _item.title,
                    iso: _item.iso,
                    symbol: _item.symbol,
                    rate: _item.rate,
                    is_deprecated: _item.is_deprecated,
                    is_fun: _item.is_fun
                }, function () {
                    _this.props.state.setExtBreadCrumbPath(_this.props.lang.editor.breadcrumb.edit_currency);
                });
            }
        }
        else {
            this.setState({
                title: "",
                symbol: "",
                is_deprecated: false,
                iso: "",
                rate: 1,
                is_fun: false,
            }, function () {
                _this.props.state.setExtBreadCrumbPath(_this.props.lang.editor.breadcrumb.new_currency);
            });
        }
        this.doReSetRules();
    };
    CfgCurrencyEditor.prototype.doReSetRules = function () {
        this.setState({
            title_rules: { isError: false },
            rate_rules: { isError: false },
            iso_rules: { isError: false },
            symbol_rules: { isError: false },
        });
    };
    CfgCurrencyEditor.prototype.OnUpdateDataClick = function () {
        var _this = this;
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                rate: this.state.rate,
                iso: this.state.iso,
                is_fun: this.state.is_fun,
                symbol: this.state.symbol,
                title: this.state.title,
                is_deprecated: this.state.is_deprecated
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify(_this.props.lang.editor.message.currency_changed);
            });
        }
    };
    CfgCurrencyEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((!this.state.title) || (this.state.title.length === 0)) {
            this.setState({
                title_rules: {
                    isError: true,
                    errorMessage: this.props.lang.editor.error.field_title_empty
                }
            });
            return false;
        }
        if ((!this.state.iso) || (this.state.iso.length === 0)) {
            this.setState({
                iso_rules: {
                    isError: true,
                    errorMessage: this.props.lang.editor.error.field_iso_empty
                }
            });
            return false;
        }
        if ((!this.state.symbol) || (this.state.symbol.length === 0)) {
            this.setState({
                symbol_rules: {
                    isError: true,
                    errorMessage: this.props.lang.editor.error.field_symbol_empty
                }
            });
            return false;
        }
        if ((!this.state.rate) || (this.state.rate <= 0)) {
            this.setState({
                rate_rules: {
                    isError: true,
                    errorMessage: this.props.lang.editor.error.field_rate_empty
                }
            });
            return false;
        }
        return true;
    };
    CfgCurrencyEditor.prototype.OnNewDataClick = function () {
        var _this = this;
        if (this.isDataValid()) {
            this.props.data.AddData({
                iso: this.state.iso,
                is_fun: this.state.is_fun,
                rate: this.state.rate,
                symbol: this.state.symbol,
                title: this.state.title,
                is_deprecated: this.state.is_deprecated
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify(_this.props.lang.editor.message.currency_added);
            });
        }
    };
    CfgCurrencyEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    CfgCurrencyEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return this.props.lang.editor.title.new_currency;
        }
        else {
            return this.props.lang.editor.title.edit_currency;
        }
    };
    CfgCurrencyEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 450 },
            React.createElement(CardRowTextEditor_1.default, { texts: {
                    caption: this.props.lang.editor.fields.title.caption,
                    placeholder: this.props.lang.editor.fields.title.placeholder
                }, value: this.state.title, onValueChanged: function (newVal) {
                    _this.setState({
                        title: newVal,
                        title_rules: { isError: false }
                    });
                }, required: true, rules: this.state.title_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: {
                    caption: this.props.lang.editor.fields.iso.caption,
                    placeholder: this.props.lang.editor.fields.iso.placeholder
                }, value: this.state.iso, onValueChanged: function (newVal) {
                    _this.setState({
                        iso: newVal,
                        iso_rules: { isError: false }
                    });
                }, required: true, rules: this.state.iso_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: {
                    caption: this.props.lang.editor.fields.symbol.caption,
                    placeholder: this.props.lang.editor.fields.symbol.placeholder
                }, value: this.state.symbol, onValueChanged: function (newVal) {
                    _this.setState({
                        symbol: newVal,
                        symbol_rules: { isError: false }
                    });
                }, required: true, rules: this.state.symbol_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: {
                    caption: this.props.lang.editor.fields.exchange_rate.caption,
                    placeholder: this.props.lang.editor.fields.exchange_rate.placeholder
                }, values: {
                    max: 999999999,
                    min: 0,
                    value: this.state.rate
                }, onValueChanged: function (newVal) {
                    _this.setState({
                        rate: newVal,
                        rate_rules: { isError: false }
                    });
                }, rules: this.state.rate_rules, precision: 3 }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: this.props.lang.editor.checkboxes.is_deprecated, value: this.state.is_deprecated, onChecked: function (checked) { _this.setState({ is_deprecated: checked }); } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: this.props.lang.editor.checkboxes.is_fun, value: this.state.is_fun, onChecked: function (checked) { _this.setState({ is_fun: checked }); } }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: {
                    btnEdit: this.props.lang.editor.buttons.save,
                    btnNew: this.props.lang.editor.buttons.create,
                    btnGoBack: this.props.lang.editor.buttons.back
                }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    return CfgCurrencyEditor;
}(React.Component));
exports.default = CfgCurrencyEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cfg_currency/ui/component/CfgCurrencyEditor.tsx
// module id = 2039
// module chunks = 0